export default __webpack_public_path__ + "static/media/period.367936e8.svg";